import React from 'react';
import { PropertiesList } from '../../models/propertyModel';

type Props = {
  property: PropertiesList;
  currentUserCountryCode: string;
};

const PropertyLinksDetail: React.FC<Props> = ({ property, currentUserCountryCode }) => {
  const ventaHasLink = property.url_sale_detail && property.sale_state === 'published';
  const rentaHasLink = property.url_sale_detail && property.state === 'published';

  return (
    <div>
      {/* Renta */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '24px 60px 1fr 24px',
        alignItems: 'center',
        gap: 0,
        minHeight: 28,
      }}>
        <i className="fas fa-home" style={{ color: '#17a2b8', fontSize: 15, justifySelf: 'center' }} />
        <span style={{ fontWeight: 600, color: '#17a2b8' }}>Renta</span>
        {rentaHasLink ? (
          <a
            href={`${process.env.REACT_APP_PROPI_WEB}/${currentUserCountryCode}/alquiler/${property.url_detail}/${property.code}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Ver página de renta"
            style={{ marginLeft: 6, color: '#17a2b8', fontSize: 14 }}
          >
            <i className="fas fa-external-link-alt" />
          </a>
        ) : (
          <span style={{ marginLeft: 6, color: '#ccc', fontSize: 14 }}>
            <i className="fas fa-external-link-alt" />
          </span>
        )}
      </div>
      {/* Venta */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '24px 60px 1fr 24px',
        alignItems: 'center',
        gap: 0,
        minHeight: 28,
      }}>
        <i className="fas fa-tag" style={{ color: '#6f42c1', fontSize: 15, justifySelf: 'center' }} />
        <span style={{ fontWeight: 600, color: '#6f42c1' }}>Venta</span>
        {ventaHasLink ? (
          <a
            href={`${process.env.REACT_APP_PROPI_WEB}/${currentUserCountryCode}/venta/${property.url_sale_detail}/${property.code}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Ver página de venta"
            style={{ marginLeft: 6, color: '#6f42c1', fontSize: 14 }}
          >
            <i className="fas fa-external-link-alt" />
          </a>
        ) : (
          <span style={{ marginLeft: 6, color: '#ccc', fontSize: 14 }}>
            <i className="fas fa-external-link-alt" />
          </span>
        )}
      </div>
    </div>
  );
};

export default PropertyLinksDetail;